let searchInputs = [
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference'
    },
    {
        id: 'username',
        label: 'User',
        type: 'text',
        placeholder: 'User email'
    },
    {
        id: 'taskType',
        label: 'Task Type',
        type: 'select',
        options: [

        ]
    }
]

export { searchInputs }